module.exports = __webpack_public_path__ + "static/img/bg_2_4.cb84745.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_2_4.png
// module id = guSy
// module chunks = 3